import type { InjectionKey } from 'vue'

export const TELEPORT_ID_KEY = Symbol() as InjectionKey<string>
